<template>
  <section v-if="questionnaireContent != null">
    <template v-if="!started">
      <table class="table my-4">
        <tbody>
          <tr>
            <th class="text-end">
              アンケート名
            </th>
            <td>
              {{questionnaireName}}
            </td>
          </tr>
          <tr>
            <th class="text-end">
              最大質問数
            </th>
            <td>
              {{questionnaireContent.questions.length}}
            </td>
          </tr>
        </tbody>
      </table>

      <section class="my-4">
        <button type="button" class="btn btn-primary w-100" v-on:click="startQuestionnaire()">
          開始
        </button>
      </section>
    </template>

    <template v-if="started">
      <section>
        <section class="my-4 border-bottom">
          <h6 class="my-4">
            <span>
              質問 {{questionIndex + 1}}
            </span>
            <span v-if="selectedQuestion.isAnswerRequired"
                  class="text-danger fw-bold user-select-none">*</span>
          </h6>
          <div class="my-4">
            {{selectedQuestion.questionBody}}
          </div>
        </section>
        <section class="my-4 border-bottom user-select-none">
          <h6 class="my-4">
            回答
          </h6>

          <template v-if="selectedQuestion.answerMethod=='singleSelection'">
            <section class="my-4">
              <div v-for="choice in selectedQuestion.choices"
                   class="p-2 border rounded-3 d-flex align-items-center my-2">
                <input type="radio" :name="'__single_selection_' + selectedQuestion.id"
                       :id="'__single_selection_' + selectedQuestion.id + '_' + choice.id"
                       :value="choice.id"
                       class="form-check-input mx-2 my-auto"
                       :checked="choiceSelected(choice)"
                       v-on:change="selectChoice($event, choice)" />
                <label :for="'__single_selection_' + selectedQuestion.id + '_' + choice.id"
                       class="form-check-label flex-grow-1">
                  {{choice.detail}}
                </label>
              </div>
            </section>
          </template>

          <template v-if="selectedQuestion.answerMethod=='multipleSelection'">
            <section class="my-4">
              <div v-for="choice in selectedQuestion.choices"
                   class="p-2 border rounded-3 d-flex align-items-center my-2">
                <input type="checkbox" :name="'__multiple_selection_' + selectedQuestion.id"
                       :id="'__multiple_selection_' + selectedQuestion.id + '_' + choice.id"
                       :value="choice.id"
                       class="form-check-input mx-2 my-auto"
                       :checked="choiceSelected(choice)"
                       v-on:change="selectChoice($event, choice)" />
                <label :for="'__multiple_selection_' + selectedQuestion.id + '_' + choice.id"
                       class="form-check-label flex-grow-1">
                  {{choice.detail}}
                </label>
              </div>
            </section>
          </template>

          <template v-if="selectedQuestion.answerMethod=='sort'">
            <draggable v-model="selectedQuestion.choices"
                       item-key="selectedQuestion.choices"
                       handle=".handle"
                       animation="300">
              <template #item="{element}">
                <div v-bind:key="element.id"
                     class="d-flex align-items-center handle border rounded-3 p-2 my-2"
                     role="row">
                  <svgicon role="gridcell" name="list" />
                  <span role="gridcell" class="ms-2 flex-grow-1">{{element.detail}}</span>
                </div>
              </template>
            </draggable>
          </template>

          <template v-if="selectedQuestion.answerMethod=='descriptive'">
            <textarea type="text" class="form-control my-4"></textarea>
          </template>

        </section>
      </section>

      <section class="d-flex">
        <button type="button"
                class="btn btn-outline-success me-auto"
                v-on:click="moveQuestion(-1)"
                v-if="!firstQuestionSelected">
          前の質問
        </button>
        <button type="button"
                class="btn btn-outline-primary ms-auto"
                v-on:click="moveQuestion(1)"
                v-if="!lastQuestionSelected">
          次の質問
        </button>
      </section>
    </template>
  </section>
</template>

<script>
  import { defineComponent } from "vue";
  import draggable from "vuedraggable";

  export default defineComponent({
    props: {
      questionnaire: {
        type: Object,
        required: true,
      },
      questionnaireName: {
        type: String,
        default: null,
      },
    },
    computed: {
      selectedQuestion() {
        if (this.questionnaireContent == null) return null;
        return this.questionnaireContent.questions[this.questionIndex];
      },
      firstQuestionSelected() {
        return this.questionIndex === 0;
      },
      lastQuestionSelected() {
        return this.questionnaireContent.questions.length - 1 === this.questionIndex;
      },
    },
    data: () => {
      return {
        questionnaireContent: null,
        started: false,
        questionIndex: 0,
      }
    },
    methods: {
      startQuestionnaire() {
        this.started = true;
      },
      moveQuestion(num) {
        let val = this.questionIndex + (num);
        if (0 <= val && val < this.questionnaireContent.questions.length) this.questionIndex = val;
      },
      choiceSelected(choice) {
        if (this.selectedQuestion == null || this.selectedQuestion.choices.length === 0) return null;
        return this.selectedQuestion.choices.some(c => c.selected === true && c.id === choice.id);
      },
      selectChoice(e, choice) {
        if (this.selectedQuestion == null || this.selectedQuestion.choices.length === 0) return null;
        if (this.selectedQuestion.answerMethod === "singleSelection") {
          this.selectedQuestion.choices.forEach(c => c.selected = false);
        }
        this.selectedQuestion.choices.find(c => c.id === choice.id).selected = e.target.checked;
      },
    },
    beforeCreate() {
    },
    created() {
    },
    mounted() {
      this.questionnaireContent = this.questionnaire;
    },
    emits: ["start",],
    components: {
      "draggable": draggable,
    },
    watch: {
    }
  });

</script>
